<button
  tuiIconButton
  type="button"
  appearance="icon"
  size="s"
  [routerLink]="'/chats-inner/configs'"
  iconStart="@tui.settings"
></button>
